import React, { useContext, useState } from 'react';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { DatePicker as AntDatePicker, notification } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import { AuthContext } from './Auth/Auth';
import {
    ParPagComponentRequest,
    updatePageComponent,
} from 'services/displayFramework';
import { DatePickerProps as AntDatePickerProps } from 'antd/lib/date-picker';

export type DatePickerProps = Omit<AntDatePickerProps, 'children'> & {
    comcode: string;
    Inspectstyle?: React.CSSProperties;
};

const DatePicker = ({ comcode, Inspectstyle, ...otherProps }: DatePickerProps) => {
 
    const { isHidden, label, style, isDisabled } = useComponentConfiguration(comcode);
    const { pagcode, refresh } = useDisplayFrameworkContext();
    const { isInspect } = useContext(AuthContext);
    const [newLabel, setNewLabel] = useState('');

    if (isHidden) {
        return null;
    }

    const handleSaveNewLabel = (comcode: string, labelp: string) => {
        const request: ParPagComponentRequest = {
            comcode: comcode ?? '',
            comformat: '',
            comhint: '',
            comlabel: newLabel === '' ? label : labelp,
            commessage: '',
            complaceholder: '',
            comrequired: false,
            comstyle: '',
            comtype: '',
            pagcode: pagcode ?? '',
        };

        updatePageComponent({ request: request }).then((res) => {
            if (res.code === '200')
                notification.success({
                    message: res.message,
                    description: res.description,
                });
            else {
                notification.error({
                    message: res.message,
                    description: res.description,
                });
            }
            refresh();
        });
    };

    const props = {
        ...otherProps,
        children: isInspect ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <AntDatePicker
                    defaultValue={label === '' ? undefined : undefined} // You might want to parse the label if it's a date string
                    size="middle"
                    onChange={(date, dateString) => {
                        setNewLabel(dateString);
                    }}
                    style={Inspectstyle ?? { width: '50%' }}
                    className="date-picker-inspect"
                />
                <SaveOutlined
                    style={{ marginLeft: 8, cursor: 'pointer' }}
                    onClick={(ev) => {
                        ev.preventDefault();
                        handleSaveNewLabel(comcode, newLabel);
                    }}
                />
            </div>
        ) : (
            label // Display the label or potentially a formatted date
        ),
        style,
        disabled: isDisabled,
    };

    return <AntDatePicker {...props}  />;
};

export default DatePicker;